







import Component, { mixins } from 'vue-class-component';
import BaseCmsBlock from '../CmsBlockMixin';

@Component
export default class CkEditorBlock extends mixins(BaseCmsBlock) {}
